// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Row$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/custom/layout-components/Row.bs.js";
import * as Icon$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/icons/Icon.bs.js";

function SidePanelHeader(Props) {
  var on_close_click = Props.on_close_click;
  var heading = Props.heading;
  var class_nameOpt = Props.class_name;
  var class_name = class_nameOpt !== undefined ? class_nameOpt : "";
  return React.createElement(Row$Catalyst.make, {
              children: null,
              className: "header " + class_name
            }, React.createElement("div", {
                  className: "heading"
                }, heading), React.createElement("div", {
                  className: "close-icon",
                  onClick: (function (_e) {
                      return Curry._1(on_close_click, undefined);
                    })
                }, React.createElement(Icon$Catalyst.CloseIcon.make, {})));
}

var make = SidePanelHeader;

export {
  make ,
  
}
/* react Not a pure module */
